import { useRef } from 'react';
import type { DatePickerProps as AriaDatePickerProps, DateValue, ValidationResult } from 'react-aria-components';
import { DatePicker as AriaDatePicker, Button, CalendarCell, CalendarGrid, CalendarGridHeader, CalendarHeaderCell, CalendarGridBody, DateInput, DateSegment, Dialog, FieldError, Heading, Label, Popover, Calendar, Text } from 'react-aria-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalendarDay } from '@fortawesome/free-solid-svg-icons/faCalendarDay';



interface DatePickerProps<T extends DateValue> extends AriaDatePickerProps<T> {
	label?: string;
	description?: string;
	errorMessage?: string | ((validation: ValidationResult) => string);
}


export function DatePicker<T extends DateValue>(props: DatePickerProps<T>) {
	const { label, isRequired = false, description, errorMessage, ...otherProps } = props;

	let buttonRef = useRef<HTMLButtonElement>(null);
	
	return (
		<AriaDatePicker {...otherProps} isRequired={isRequired}>

			<Label>{label} {isRequired && <span>*</span>}</Label>
			
			<Button ref={buttonRef}>
				<DateInput>
					{(segment) => <DateSegment segment={segment} />}
				</DateInput>
				
				<span aria-hidden="true" className='react-aria-PickerButton'>
					<FontAwesomeIcon icon={faCalendarDay} />
				</span>
			</Button>
			
			{description && <Text slot="description">{description}</Text>}
			<FieldError>{errorMessage}</FieldError>
			
			<Popover triggerRef={buttonRef}>
				<Dialog>
					<Calendar>
					
						<header>
							<Button slot="previous">◀</Button>
							<Heading />
							<Button slot="next">▶</Button>
						</header>
					
						<CalendarGrid weekdayStyle='short'>
							<CalendarGridHeader>
								{(day) => <CalendarHeaderCell>{day.charAt(0).toUpperCase() + day.slice(1)}</CalendarHeaderCell>}
							</CalendarGridHeader>

							<CalendarGridBody>
								{(date) => <CalendarCell date={date} />}
							</CalendarGridBody>
						</CalendarGrid>
					
					</Calendar>
				</Dialog>
			</Popover>
		
		</AriaDatePicker>
	);
}